import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, Phone, MapPin, Shield } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export const Footer = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <h3 className="text-3xl font-bold bg-gradient-to-r from-white to-amber-400 bg-clip-text text-transparent mb-4">
              DUGEZ
            </h3>
            <p className="text-gray-400 leading-relaxed">
              Biocamini di lusso per trasformare ogni ambiente in un'esperienza unica di eleganza e comfort.
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contatti</h4>
            <div className="space-y-3">
              <a
                href="mailto:info@dugez.com"
                className="flex items-center gap-3 text-gray-400 hover:text-amber-400 transition-colors duration-300"
              >
                <Mail className="w-5 h-5" />
                <span>info@dugez.com</span>
              </a>
              <a
                href="https://wa.me/393123456789"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-gray-400 hover:text-amber-400 transition-colors duration-300"
              >
                <Phone className="w-5 h-5" />
                <span>WhatsApp</span>
              </a>
              <div className="flex items-center gap-3 text-gray-400">
                <MapPin className="w-5 h-5" />
                <span>Italia</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Link Utili</h4>
            <div className="space-y-3">
              <a
                href="https://dugez.com"
                target="_blank"
                rel="noopener noreferrer"
                className="block text-gray-400 hover:text-amber-400 transition-colors duration-300"
              >
                Sito Principale
              </a>
              <a
                href="#products"
                className="block text-gray-400 hover:text-amber-400 transition-colors duration-300"
              >
                Catalogo Prodotti
              </a>
              <a
                href="#benefits"
                className="block text-gray-400 hover:text-amber-400 transition-colors duration-300"
              >
                Vantaggi
              </a>
              <button
                onClick={() => navigate(isAuthenticated ? '/admin/dashboard' : '/admin/login')}
                className="flex items-center gap-2 text-gray-400 hover:text-amber-400 transition-colors duration-300"
              >
                <Shield className="w-4 h-4" />
                {isAuthenticated ? 'Pannello Admin' : 'Area Admin'}
              </button>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-12 pt-8 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} DUGEZ. Tutti i diritti riservati.</p>
        </div>
      </div>
    </footer>
  );
};